import { SliderBar } from './SliderBar';
export default SliderBar;
